(ns dashboard.router
  (:require
   [goog.uri.utils :as gu]
   [reitit.frontend :as rfr]
   [reitit.frontend.history :as rtfh]
   [reitit.frontend.easy :as rfe]
   [reitit.frontend.controllers :as rfc]
   [reitit.coercion.schema :as rsc]
   [re-frame.core :refer [dispatch subscribe reg-fx]]
   [dashboard.subs :as subs]
   [dashboard.views :as views]
   ["@heroicons/react/outline" :refer
    [BellIcon BriefcaseIcon CogIcon CreditCardIcon KeyIcon UserCircleIcon
     UserIcon UsersIcon UserGroupIcon CalendarIcon ViewGridAddIcon CubeIcon
     TicketIcon]]))

;;; Effects ;;;

;; Triggering navigation from events.

(reg-fx
 :navigate!
 (fn [[route route-params query-map]]
   (rfe/push-state route route-params query-map)))

;; Controllers

(defn- dispatch-events
  "Creates a controller that dispatches events defined in key of route."
  [key]
  (fn [match]
    (when-let [events (get-in match [:data key])]
      (let [params (merge
                    (-> match :parameters :path)
                    (-> match :parameters :query))]
        (doseq [evt (map #(if (vector? %) % [%]) events)]
          (dispatch (conj evt params)))))))

;; -------------------------
;; Routes

(def routes
  ["/"
   [""
    {:view #'views/main-panel
     ;; Common controllers - used for all routes
     :controllers [{:identity identity
                    :start (dispatch-events :route/load)
                    :stop (dispatch-events :route/on-leave)}]}

    ["loading"
     {:name :route.login/loading
      :title :route.title/loading
      :view #'views/loading-page}]

    ["login"
     {:name :route.login/login
      :title :route.title/login
      :view #'views/login-page}]

    ["home"
     {:name :route.home/home
      :title :route.title/home}]

    ["rooms"
     {:name :route.rooms/rooms
      :title :rooms
      :route/load [:dashboard.events.rooms/list-rooms-by-event]}]

    ["settings"
     {:title :route.title/settings
      :sub-routes [:route.settings/profile
                   :route.settings/organization
                   :route.settings/events
                   :route.settings/users]
      :event-settings [:route.settings/rooms
                       :route.settings/bookings]}
     ["/profile"
      {:name :route.settings/profile
       :title :route.title/profile
       :subtitle "Your personal information for communication purpose."
       :icon UserCircleIcon
       :route/load [:dashboard.events.users/get-userinfo]}]

     ["/account"
      {:name :route.settings/account
       :title :route.title/account
       :subtitle "Account related information for programmatic access to our service."
       :icon CogIcon}]

     ["/organization"
      {:name :route.settings/organization
       :title :route.title/organization
       :subtitle "Company settings configuration."
       :icon BriefcaseIcon
       :resource :settings/organization}]

     ["/spaces"
      {:name :route.settings/spaces
       :title :route.title/spaces
       :subtitle "Stores, pop-up and venues configuration."
       :icon CubeIcon
       :resource :settings/spaces
       :route/load [:dashboard.events.spaces/list-spaces-by-organization]}]

     ["/users"
      {:name :route.settings/users
       :title  :route.title/employees
       :subtitle "Users Directory."
       :icon UserIcon
       :resource :settings/users
       :route/load [:dashboard.events.users/list-users-by-organization]}]

     ["/roles"
      {:name :route.settings/roles
       :title :route.title/roles
       :subtitle "User roles settings configuration."
       :icon UsersIcon
       :resource :settings/roles}]

     ["/calendars"
      {:name :route.settings/calendars
       :title :route.title/calendars
       :subtitle "Organization calendars configuration."
       :icon CalendarIcon
       :resource :settings/calendars
       :route/load [:dashboard.events.calendars/list-calendars-by-organization]}]

     ["/events"
      {:name :route.settings/events
       :title :route.title/events
       :subtitle "Events settings."
       :icon CalendarIcon
       :resource :settings/events
       :route/load [:dashboard.events.events/list-events-by-organization]}]

     ;; Event Organizer Settings

     ["/event/:event-id/rooms"
      {:name :route.settings/rooms
       :title :route.title/rooms
       :subtitle "Event Rooms configuration."
       :icon CubeIcon
       :resource :settings/rooms
       :route/load [:dashboard.events.rooms/list-rooms-by-event]}]

     ["/event/:event-id/bookings"
      {:name :route.settings/bookings
       :title :route.title/bookings
       :subtitle "Event Bookings configuration."
       :icon TicketIcon
       :resource :settings/bookings
       :route/load [:dashboard.events.bookings/list-bookings-by-event]}]

     ["/event/:event-id/guests"
      {:name :route.settings/guests
       :title :route.title/guests
       :subtitle "Event Guests configuration."
       :icon UsersIcon
       :resource :settings/guests}]]]])

;; -------------------------
;; Reitit Router

(def router
  (rfr/router
   routes
   {:data {:coercion rsc/coercion}}))

(defn- apply-controllers [old-match new-match]
  (assoc new-match :controllers (rfc/apply-controllers (:controllers old-match) new-match)))

(defn on-navigate [new-match]
  (when new-match
    (let [old-match @(subscribe [::subs/current-route])
          authenticated? true ;; @(subscribe [:logged-in?])
          ]
      (dispatch [:clear-last-error])
      (when (or authenticated?
                (= :login (get-in new-match [:data :name])))
        (dispatch [:set-current-route (apply-controllers old-match new-match)])))))

(defn app-routes []
  (rfe/start!
   router
   on-navigate
   {:use-fragment false}))

(defn route-for
  "Given a route keyword, return the matched route or nil"
  ([route-keyword]
   (rfr/match-by-name router route-keyword))
  ([route-keyword params]
   (rfr/match-by-name router route-keyword params)))

(defn match
  "Try to match a URL, returning a map of {:route-handler :route-params :alternatives}."
  [url]
  (when-let [match (rfr/match-by-path router url)]
    (println "URL match:" match)
    match))
